import React from 'react';
import { Card } from '@core-ui/Components/ui/card';

const HomeTab: React.FC = () => {

  return (
    <div className="h-screen">
      <Card className="relative bg-card/70 border-card/70 rounded-md h-full">

      </Card>
    </div>
  );
};

export default HomeTab;